import {BaseApi} from "@/core/api/base.api";
import {roomMirroringService} from "@/core/service/room.mirroring.service";
import {Room} from "@/core/api/room.api";

class RoomMirroringApi extends BaseApi {
  constructor() {
    super()
    Room.Mirroring = this;
    Room.ready(async e => {
      this._eventListen(this.#Events);
    })
  }
  #Events = {
    room_mirroring_event(e) {
      Room.emit(e);
    },
  }

  async sendEvent(data) {
    if (!data) return;
    return await roomMirroringService.sendEvent(data)
  }
}

export const RoomMirroring = new RoomMirroringApi();